.task-quick-options {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    margin-top: 5px;
}

.task-quick-options--inline {
    margin-top: 0;
}

.task-quick-chip {
    border: 1px solid #dfe3e8;
    background: #f7f8fa;
    border-radius: 4px;
    color: #1b1b1b;
    cursor: pointer;
    font-size: 11px;
    line-height: 1;
    padding: 5px 7px;
}

.task-quick-chip:hover,
.task-quick-chip:focus-visible,
.task-quick-chip.is-selected {
    border-color: #fed230;
    background: #fff8d7;
    outline: none;
}

.task-quick-chip:disabled {
    cursor: not-allowed;
    opacity: 0.55;
}
